<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container my-5" >
                <template #default>   <m-h3 v-bind='{...{},...{}}' :style='""' class="text-center mb-5" >
                <template #default>بارهای اطراف من    </template>
                </m-h3><m-products-307-nearest-product v-bind='{...{"productCardName":"mProductCard3_1","cardCLass":"my-1","cardWrapperCLass":"col-lg-4 archive-parent-item","offerType":"number","offerStatus":true,"cardLink":true,"cardLinkTarget":"_blank","feature_name":"\u0645\u0628\u062f\u0627","filterFeaturesId":["21"],"filterRoute":"SiteInfo"},...{}}' :style='""' class="" ></m-products-307-nearest-product></template>
                </m-div><m-filter-with-link-1 v-bind='{...{"pageName":"SiteInfo","features":null},...{}}' :style='"bottom: 5rem;  position: fixed; bottom:5rem; "' class="filter-modal " ></m-filter-with-link-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH3 from '@moeinmdn/miw-alpha-components/src/package/Tags/H3'; import mProducts307NearestProduct from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Products307NearestProduct/Products307NearestProduct'; import mFilterWithLink1 from '@moeinmdn/miw-alpha-components/src/package/Product/Filter/FilterWithLink1/FilterWithLink1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH3,mProducts307NearestProduct,mFilterWithLink1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
